import DirectToConsumerService from "../../services/DirectToConsumerService";
import { getRedirectType } from "../../utils/Utils";
import GLOBAL from "../../global";
import { fetchPurchasePackageThunks } from "../../features/purchasePackage/purchasePackageThunks";
import useChatbot from "../shared/chatbotNew/hooks/useChatbot";
import { useDispatch } from "react-redux";
import routes from "../../constants/Routes";
import { useLocation } from "react-router-dom";

const usePurchasedPackage = () => {
    const { startChatBot } = useChatbot();
    const dispatch = useDispatch();
    const location = useLocation();

    const createAssessmentFromPackage = async (orderId, cb, setShowAssessmentPurchaseModal, setInvitationRequestResponse, refreshPackages) => {
        const response = await DirectToConsumerService.purchasePackage();
        if(response.success) {
            const purchasedPackage = response?.data?.find((pkg) => pkg?.OrderGId?.toLowerCase() === orderId.toLowerCase());
            if (purchasedPackage?.IsFollowUp) {
                
                setShowAssessmentPurchaseModal(true);
                setInvitationRequestResponse({
                    ...purchasedPackage,
                    OrderId: orderId
                });
            } else {
                let response = await DirectToConsumerService.invitationRequest({ OrderId : orderId });
                if (response.success) {
                    const data = response?.data;
                    if (data && data?.InvitationId && data?.InvitationTypeId && data?.BodyRegionIds && data?.MeetingStartDate && data?.MeetingEndDate) {
                        const bodyRegionList = data?.BodyRegionIds.split(',').map(Number).filter(Boolean) || []

                        startChatBot(
                            {
                                InvitationId: data?.InvitationId,
                                BodyRegionList: bodyRegionList,
                                InvitationTypeName: getRedirectType(data?.InvitationTypeId),
                            },
                            GLOBAL?.USER_INFO?.ContactId || '', //patientId
                            data?.MeetingEndDate || '', //meetingStart
                            data?.MeetingStartDate || '', //meetingEnd
                            () => {
                                // Note: cb and refresh are already called above after successful invitation request
                                dispatch(fetchPurchasePackageThunks());

                                if (location.pathname.includes(routes.myAssessments)) {
                                    const refreshEvent = new CustomEvent('refreshMyAssessmentsTable');
                                    window.dispatchEvent(refreshEvent);
                                }
                            }
                        )
                    }
                }
            }
        }
    }

    const handlePurchasePackageForNewUser = async (packages, cb) => {
        if(GLOBAL.USER_INFO?.IsNewUser && packages.length > 0) {
            const firstPackage = packages[0];
            const orderId = firstPackage?.orderId;

            await createAssessmentFromPackage(orderId, cb);
        }
    }

    return {
        createAssessmentFromPackage,
        handlePurchasePackageForNewUser
    }
}

export default usePurchasedPackage;
